import React from 'react';
import { Navigate } from 'react-router-dom';

export const AccountSettingsPage: React.FC = () => <Navigate to="/dashboard" replace />;
